// extracted by mini-css-extract-plugin
module.exports = {"container":"ModifyPhoneSuccess_container__b6NVV","msg":"ModifyPhoneSuccess_msg__3YEGj","confirmBtn":"ModifyPhoneSuccess_confirmBtn__1bn0e"};